<template>
  <div class="small" v-if="shownProperties && shownProperties.length">
    <div class="font-weight-bold my-1">
      {{ $translate("Ceres::Template.basketAdditionalCosts") }}:
    </div>
    <ul class="ml-1 pl-3" data-testing="order-property-list">
      <order-property-value-list-item
        v-for="property in shownProperties"
        :key="property.propertyId"
        :property="property"
      ></order-property-value-list-item>
    </ul>
  </div>
</template>

<script>
import { isDefined } from "../../helper/utils";
import OrderPropertyValueListItem from "./OrderPropertyValueListItem.vue";

export default {
  name: "order-property-value-list",

  components: {
    OrderPropertyValueListItem,
  },

  props: {
    basketItem: {
      required: true,
      type: Object,
    },
  },

  computed: {
    shownProperties() {
      const shownProperties = [];
      const combinedPropertyIds = [82, 83, 84];
      const combinedProperty = {
        property: {
          names: { name: "Geburtstag" },
          value: "",
          propertyId: "82-84",
          isShownAtCheckout: true,
          isShownAsAdditionalCosts: true,
          isOrderProperty: false,
        },
      };
      const combinedPropertyValues = [];

      this.basketItem.variation.data.properties.forEach((property) => {
        const filledProperty = this.basketItem.basketItemOrderParams.find(
          (prop) => {
            return parseInt(prop.propertyId) === property.propertyId;
          }
        );

        if (combinedPropertyIds.includes(property.propertyId)) {
          let valueToAdd = "";
          if (filledProperty) {
            if (filledProperty.type === "selection") {
              valueToAdd =
                property.property.selectionValues[filledProperty.value].name;
            } else {
              valueToAdd = filledProperty.value;
            }
          }
          if (valueToAdd) {
            combinedPropertyValues.push(valueToAdd);
          }
          return;
        }

        if (isDefined(filledProperty)) {
          if (filledProperty.type === "selection") {
            property.property.value =
              property.property.selectionValues[filledProperty.value].name;
          } else {
            property.property.value = filledProperty.value;
          }
        }

        if (
          isDefined(filledProperty) ||
          this.isPropertyWithAdditionalCosts(property)
        ) {
          shownProperties.push(property);
        }
      });

      if (combinedProperty.property.value) {
        shownProperties.push(combinedProperty);
      }

      if (combinedPropertyValues.length > 0) {
        combinedProperty.property.value = combinedPropertyValues.join(".");
        shownProperties.push(combinedProperty);
      }

      return shownProperties;
    },
  },

  methods: {
    isPropertyWithAdditionalCosts(property) {
      return (
        property.property &&
        property.property.isShownAtCheckout &&
        property.property.isShownAsAdditionalCosts &&
        !property.property.isOderProperty
      );
    },
  },
};
</script>
